import { render, staticRenderFns } from "./CompanyAssets.vue?vue&type=template&id=33f1b6d4&"
import script from "./CompanyAssets.vue?vue&type=script&lang=js&"
export * from "./CompanyAssets.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports